import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { Observable } from 'rxjs';

import { Company, IUser, Project } from '@site-mate/dashpivot-shared-library';

import { AppHierarchy } from 'app/shared/model/app-hierarchy.enum';
import { ExportResponse } from 'app/shared/model/export-response.model';
import { HttpClientService } from 'app/shared/service/http-client.service';

interface IUploadFileToS3Params {
  signedPostResponse: ISignedPostResponse;
  sessionId: string;
  file: File;
  listId: string;
  user: IUser;
}

export interface ISignedPostResponse {
  url: string;
  fields: {
    bucket: string;
    key: string;
    Policy: string;
    'X-Amz-Algorithm': string;
    'X-Amz-Credential': string;
    'X-Amz-Date': string;
  };
}

@Injectable({ providedIn: 'root' })
export class ListImportService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly httpClientService: HttpClientService,
  ) {}

  getPresignedS3URL(
    folder: { hierarchy: AppHierarchy; company?: Company; project?: Project },
    listId: string,
  ): Observable<{ signedPostResponse: ISignedPostResponse; sessionParameters: ExportResponse }> {
    const folderMapping = {
      [AppHierarchy.Organisation]: { path: 'companies', id: folder.company?.id },
      [AppHierarchy.Project]: { path: 'projects', id: folder.project?.id },
    };

    const { path, id } = folderMapping[folder.hierarchy];

    const url = `${path}/${id}/lists/${listId}/presigned-csv-upload-url`;
    return this.httpClientService.get(url);
  }

  uploadFileToS3(params: IUploadFileToS3Params) {
    const { file, listId, user, sessionId } = params;
    const { fields, url } = params.signedPostResponse;
    delete fields.key;
    const formData = new FormData();

    const timezone = user.timezone || (moment as any).tz.guess();

    formData.append('key', `${user._id}/${listId}/`);
    formData.append('Content-Type', file.type);
    formData.append('x-amz-meta-original-filename', file.name);
    formData.append('x-amz-meta-session-id', sessionId);
    formData.append('x-amz-meta-timezone', timezone);

    Object.entries(fields).forEach(([key, value]) => formData.append(key, value));
    formData.append('file', file);

    return this.httpClient.post(url, formData);
  }
}
